import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { ProductIntro } from './ProductIntro';
import { TomosList } from './TomosList';
import { Bonos } from './Bonos';
import { ValueStack } from './ValueStack';
import { Urgency } from './Urgency';
import { Pricing } from './Pricing';
const LateContent = lazy(() => import('./LateContent').then(({
  LateContent: Content
}) => ({
  default: Content
})));
interface DeferredContentProps {
  onCta: () => void;
  onReady: () => void;
}

/** Long-form sales content stays outside the critical rendering path. */
export function DeferredContent({
  onCta,
  onReady
}: DeferredContentProps) {
  const lateContentTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadLateContent, setShouldLoadLateContent] = useState(false);
  useEffect(() => {
    onReady();
  }, [onReady]);
  useEffect(() => {
    const trigger = lateContentTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadLateContent(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadLateContent(true);
      observer.disconnect();
    }, {
      rootMargin: '420px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  return <>
      <ProductIntro data-id="element-40" data-mp="2w37ueuu2m804" />
      <TomosList data-id="element-41" data-mp="2w2oetkrw7vp9" />
      <Bonos data-id="element-42" data-mp="2w2681u7ltz33" />
      <ValueStack data-id="element-43" data-mp="2w5u34xsp6tjx" />
      <Urgency data-id="element-44" data-mp="2r4mvcyqk1ud9" />
      <div id="pricing" className="scroll-mt-4" data-id="element-45" data-mp="2r5617h2xksax">
        <Pricing data-id="element-46" data-mp="2r4ehb3ip4j0h" />
      </div>
      <div ref={lateContentTriggerRef} className="h-px" aria-hidden="true" data-id="element-47" data-mp="354ffucbhnecs" />
      {shouldLoadLateContent && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-49" data-mp="312khngouth38" />} data-id="element-48" data-mp="3133pu5opcr42">
          <LateContent onCta={onCta} data-id="element-50" data-mp="310zo9uea046y" />
        </Suspense>}
    </>;
}